import { useCallback, useState } from "react";
import { isPeriod } from "./filterChoices";

/**
 * Used by the UserFilter Filter popup.
 * Encapsulates logic to for storing and updating filter popup state.
 * Does not persist to database.
 */
export function useUserFilters(initialFilters = []) {
  const [filters, setFilters] = useState(initialFilters);

  const updateFilters = useCallback(
    (change) => {
      const { type } = change;
      const changedFilters = filters.filter(
        (item) => isPeriod(type) ^ isPeriod(item) // XOR, since we keep area if incoming is period, else we keep period
      );
      changedFilters.push(type);
      setFilters(changedFilters);
    },
    [filters, setFilters]
  );

  return [filters, updateFilters];
}
